import styled, { css } from 'styled-components';

import { IDisableChildrenContainer, IDisableChildrenCover } from './types';

export const Container = styled('div')<IDisableChildrenContainer>`
  height: ${({ height }) => (!height ? undefined : height)};
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      position: ${props.containerPosition || 'relative'};
    `}
`;

Container.defaultProps = {
  height: '100%',
  width: '100%',
};

export const Cover = styled('div')<IDisableChildrenCover>`
  ${(props) =>
    props.disabled &&
    css`
      background-color: #fff;
      height: ${props.height || '100%'};
      opacity: ${props.opacity};
      width: 100%;
      position: ${props.position};
      top: ${props.top};
      right: ${props.right};
      bottom: ${props.bottom};
      left: ${props.left};
      width: ${props.width};
      z-index: ${props.zIndex};
    `}
`;

Cover.defaultProps = {
  zIndex: 1,
  position: 'absolute',
  opacity: 0.7,
};
